import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
const TZ = 'Asia/Bangkok'

export default function calculateTaskStatus (task, masterTaskStatus) {
  if (['completed_on_time', 'completed_overdue', 'completed_critical'].includes(task.taskStatus)) {
    return masterTaskStatus[task.taskStatus]
  }

  const now = dayjs() // ตอนนี้ (local/UTC ก็ได้ เดี๋ยวแปลงเป็นไทย)

  // แปลง start / due เป็น "วันไทย"
  const startThai = dayjs(task.startDate).tz(TZ).startOf('day')
  const dueThai = dayjs(task.dueDate).tz(TZ).startOf('day')
  const todayThai = now.tz(TZ).startOf('day')

  // deadline = สิ้นวันไทยของ due
  const deadline = dueThai.endOf('day') // still in TZ

  const isOverdueNow = now.tz(TZ).isAfter(deadline)

  const daysOverDue = todayThai.diff(dueThai, 'day')
  const daysToDue = dueThai.diff(todayThai, 'day')

  if (startThai.isAfter(todayThai)) return masterTaskStatus.pending
  if (isOverdueNow && daysOverDue >= 7) return masterTaskStatus.critical
  if (isOverdueNow) return masterTaskStatus.overdue

  if (daysToDue === 0) return masterTaskStatus.dueIn0
  if (daysToDue === 1) return masterTaskStatus.dueIn1
  if (daysToDue === 2) return masterTaskStatus.dueIn2

  if (
    todayThai.isSame(startThai)
    || (todayThai.isAfter(startThai) && todayThai.isBefore(dueThai))
  ) {
    return masterTaskStatus.inProgress
  }

  return masterTaskStatus.pending
}
